import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import { DatasourceAPI, JobAPI, OrderAPI } from "api";
import {
  AlertService,
  DateService,
  ErrorService,
  FormService,
  NumberService,
} from "@standard/services";
import { useForm } from "react-hook-form";
import { JOB_STATUS, JobStatusComponent } from "data/jobStatus";
import Modal from "@standard/components/Modal";
import AlertBar from "@standard/components/AlertBar";
import JobHistories from "../Job/JobHistories";
import JobDocuments from "../Job/JobDocuments";
import { USER_ROLE } from "data/constants";
import JobInfo from "../JobUpload/JobInfo";

export default ({ history, url }) => {
  const { id, action, role } = useParams();
  const [errors, setErrors] = useState([]);
  const [disabled, setDisabled] = useState(action === "view");
  const [isLoading, setIsLoading] = useState(true);
  const [jobHistories, setJobHistories] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [jobInfo, setJobInfo] = useState({ jobAuthenHistories: [] });
  const defaultValues = { id: id };

  const reactHookForm = useForm({ defaultValues });

  useEffect(() => {
    if (id !== undefined) retrieveData(id);
  }, []);

  const retrieveData = (id) => {
    FormService.getRequest(url, id).then((result) => {
      setJobHistories(result.jobHistories);
      setDocuments(result.documents);
      setJobInfo(result);
      setIsLoading(false);
    });
  };

  const onSubmit = () => {};

  const tabs = [
    {
      name: "document",
      label: "Documents",
      fields: [
        {
          type: "custom",
          control: (
            <JobDocuments
              key="jobDocuments"
              values={documents}
              disabled={true}
            />
          ),
        },
      ],
    },
    {
      name: "history",
      label: "History",
      fields: [
        {
          type: "custom",
          control: <JobHistories key="jobHistories" values={jobHistories} />,
        },
      ],
    },
    {
      name: "authenhistory",
      label: "Authen History",
      fields: [
        {
          type: "custom",
          control: (
            <JobHistories
              key="authenHistories"
              values={jobInfo.jobAuthenHistories}
            />
          ),
        },
      ],
    },
  ];

  const fieldErrors = ErrorService.convertToArray(
    reactHookForm.formState.errors
  );

  let buttons = [];
  if (disabled === false) {
    buttons = [
      <Modal
        key="approve"
        label={
          <>
            <i className="fa fa-thumbs-up"></i> Approve
          </>
        }
        fields={[{ label: "Message", name: "message", type: "textarea" }]}
        title="Approve"
        variant="primary"
        btnClass="mr-2"
        enableSave={true}
        onSave={(value) => {
          const promise = new Promise((resolve) => {
            AlertService.confirm("Do you want to approve ?").then((res) => {
              if (res === true) {
                setIsLoading(true);
                JobAPI.authenDocument(role, id, "approve", value).then(
                  (res) => {
                    AlertService.done("Approve complete").then(() => {
                      history.push(`/${url}`);
                    });
                  }
                );
              } else {
                resolve({ show: false });
              }
            });
          });
          return promise;
        }}
      ></Modal>,
      <Modal
        headerClass="bg-danger"
        key="reject"
        label={
          <>
            <i className="fa fa-ban"></i> Reject
          </>
        }
        fields={[
          { label: "Message", name: "message", type: "textarea" },
          {
            label: "Attach File",
            name: "assets",
            type: "file",
            multiple: true,
          },
        ]}
        title="Reject"
        variant="danger"
        btnClass="mr-2"
        enableSave={true}
        onSave={(value) => {
          const promise = new Promise((resolve) => {
            AlertService.confirm("Do you want to reject ?").then((res) => {
              if (res === true) {
                setIsLoading(true);
                JobAPI.authenDocument(role, id, "reject", value).then((res) => {
                  AlertService.done("Reject complete").then(() => {
                    history.push(`/${url}`);
                  });
                });
              } else {
                resolve({ show: false });
              }
            });
          });
          return promise;
        }}
      ></Modal>,
    ];
  }

  const leftPanel = (
    <div>
      <JobStatusComponent value={reactHookForm.getValues("status")} />
    </div>
  );

  return (
    <BoxContainer loading={isLoading} errors={errors.concat(fieldErrors)}>
      <>
        <JobInfo value={jobInfo} />
        <DataForm
          leftPanel={leftPanel}
          refForm={reactHookForm}
          tabs={tabs}
          buttons={buttons}
          url={url}
          enableSave={false}
          enableTabs={true}
          onSubmit={onSubmit}
        ></DataForm>
      </>
    </BoxContainer>
  );
};
